module.exports = __webpack_public_path__ + "img/sean-cordero5.9927e554.png";